import { Segment, Text } from "@simplybusiness/mobius";

export const JourneyContinuationNotice = ({
  continuationProduct,
}: JourneyContinuationProps) => {
  return (
    <Segment>
      <Text elementType="h4" spacing="loose">
        We did not forget about {continuationProduct}
      </Text>
      <Text elementType="span">
        We will get your {continuationProduct} quote right after you checkout.
      </Text>
    </Segment>
  );
};

export type JourneyContinuationProps = {
  continuationProduct: string;
};
